<template>
  <div class="permission-popup">
    <div
      class="head"
    >
      <div class="wrapper">
        <div class="popup-title">
          {{ locales('push_permission_title') }}
        </div>
      </div>
    </div>
    <div class="body">
      <div class="pic">
        <img
          :src="img"
          alt=""
        >
      </div>
      <div
        class="popup-text text"
        v-html="text"
      />
      <button
        class="popup-btn blue-btn"
        @click="clickPermission"
      >
        {{ locales('request_permission') }}
      </button>
    </div>
  </div>
</template>

<script>
import app from '../../../app';
// import userNotificationsModel from '../../../models/userNotifications';
import _ from '../../../libs/lodash';

export default {
  data() {
    return {
      locales: __,
      img: `${GT.cdn}/imgs/notifications/example_push_notification.png`,
      text: __('request_notification_permission_text'),
    };
  },
  methods: {
    async clickPermission() {
      await Notification.requestPermission(permission => {
        if (permission === 'granted') {
          this.$store.dispatch('userNotification/subscribeToPushNotifications');
          // userNotificationsModel.subscribeToPushNotifications();
          // userNotificationsModel.switchDesktopNotifications(1)
          this.$store.dispatch('userNotification/switchDesktopNotifications', { trigger: 1 }).then(() => {
            _.delay(() => {
              app.trigger('userProfile:showNotifications');
            }, 100);
          });
        }
        if (permission === 'denied') {
          // userNotificationsModel.switchDesktopNotifications(0);
          this.$store.dispatch('userNotification/switchDesktopNotifications', { trigger: 0 });
          webix.message({ type: 'warning', text: __('blocked_or_incognito_mode_push') });
        }
      });
      await this.$store.dispatch('globalPopup/close');
    },
  },
};
</script>

<style scoped lang='less'>
.permission-popup {
  text-align: center;

  .body {
    padding: 24px 74px !important;

  .pic {
    margin-bottom: 24px;
  }

  .text {
    margin-bottom: 48px;
      color: #424242;
    }
  }
}
</style>
